"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TagEnum;
(function (TagEnum) {
    TagEnum["ContractProvided"] = "Contract provided";
    TagEnum["ContractSigned"] = "Contract signed";
    TagEnum["DepositPaid"] = "Deposit paid";
    TagEnum["UnitAssigned"] = "Unit assigned";
})(TagEnum = exports.TagEnum || (exports.TagEnum = {}));
